import type { TRuleWithTheme } from '@/styles/theme';

export const itemLabel: TRuleWithTheme = () => ({
    flex: 1,
    minWidth: 0,
});

export const selectionLabel: TRuleWithTheme = ({ theme }) => ({
    flexShrink: 0,
    fontWeight: 600,
    fontSize: '0.625rem',
    color: theme.colors.foregroundsTertiary,
});

export const chevronRight: TRuleWithTheme = ({ theme }) => ({
    flexShrink: 0,
    color: theme.colors.iconsSecondary,
});
